import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi'//  'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        base: '#1b75b1',
        alert: '#df6B6e',
        backGrey: '#f6f6f6',
        grayish: '#787878',
        cancelBtn: '#f6f6f6',
        cancelBtnText: '#5b5b5b'
      }
    }
  }
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js